import { I18nString } from 'src/app/_models'
import { Factory } from '../../_models/interface/factory'
import { rememberPayload, objectSchema, parseEntity } from '../../_utils/fcdc-v2'

const messagePayload = objectSchema({})

export class MessageRequest {
  private type: MessageRequestType
  private siteId: string
  messages: I18nString[]
  sessionIds: string[]
  constructor(json: any) {
    this.type = json.type
    this.siteId = json.siteId
    this.messages = json.messages
    this.sessionIds = json.sessionIds
    rememberPayload(this, json)
  }

  static getFactory(): Factory<MessageRequest> {
    return new (class implements Factory<MessageRequest> {
      make(json: any): MessageRequest {
        switch (json.type) {
          case MessageRequestType.Email:
            return new EmailMessageRequest(json)
          case MessageRequestType.Sms:
            return new SmsMessageRequest(json)
          default:
            return parseEntity(messagePayload, json ?? {}) as unknown as MessageRequest
        }
      }

      getTableName(): string {
        throw new Error('MessageRequest has no table')
      }
    })()
  }
  getSiteId() {
    return this.siteId
  }

  getUrl() {
    switch (this.type) {
      case MessageRequestType.Email:
        return '/sites/' + this.siteId + '/notify_session_holders/email'
      case MessageRequestType.Sms:
        return '/sites/' + this.siteId + '/notify_session_holders/sms'
    }
  }
}

export class SmsMessageRequest extends MessageRequest {
  constructor(json: any) {
    super(json)
  }
}

export class EmailMessageRequest extends MessageRequest {
  subjects: I18nString[]
  constructor(json: any) {
    super(json)
    this.subjects = json.subjects
  }
}

export enum MessageRequestType {
  Email = 'Email',
  Sms = 'Sms',
}
